export default ({
    name : 'ProductHashTag'
    , props : {
        'hashTagConfig' : Object // product_basic data
    }
    , data () {
        return {
            displayTypeTextString : 'T'
            , displayTypeImgString : 'I'
            , textDesignCurveString : 'C'
            , textDesignSquareString : 'S'
        }
    }
    , created () {
        this.code = 'product_hashtag';
        this.basic = this.getDetailDataByCode(this.code);
        return {}
    }
    , mounted () {
        this.publisher()
    }
    , computed : {
        isDisplayHashTag () {
            if (typeof this.hashTagConfig.input == 'undefined' || typeof this.hashTagConfig.input.phc_display_type == 'undefined') { return false }
            return true
        }
        , isHashTagTextType () {
            return this.hashTagConfig.input.phc_display_type == this.displayTypeTextString
        }
        , isHashTagImgType () {
            return this.hashTagConfig.input.phc_display_type == this.displayTypeImgString
        }
        , inputDisplayType () {
            return this.hashTagConfig.input.phc_display_type
        }
        , inputTxtDesignType () {
            return this.hashTagConfig.input.phc_txt_design_type
        }
        , inputTxtColor () {
            return this.hashTagConfig.input.phc_txt_color
        }
        , borderClass () {
            switch (this.hashTagConfig.input.phc_display_type) {
                case this.displayTypeTextString:
                    return this.hashTagConfig.text_type.txtBoderClass
                case this.displayTypeImgString:
                    return this.hashTagConfig.img_type.imgBoderClass
                default:
                    return ''
            }
        }
        , tagList () {
            switch (this.hashTagConfig.input.phc_display_type) {
                case this.displayTypeTextString:
                    return (typeof this.hashTagConfig.text_type.tags == 'undefined') ? [] : this.hashTagConfig.text_type.tags
                case this.displayTypeImgString:
                    return (typeof this.hashTagConfig.img_type.tags == 'undefined') ? [] : this.hashTagConfig.img_type.tags
                default:
                    return []
            }
        }
        , liTagStyle () {
            return this.hashTagConfig.text_type.liTagStyle
        }
        , liTagStyleOn () {
            return this.hashTagConfig.text_type.liTagStyleOn
        }
        , aTagStyle () {
            return this.hashTagConfig.text_type.aTagStyle
        }
        , aTagStyleOn () {
            let designType = this.hashTagConfig.input.phc_txt_design_type
            let color = this.hashTagConfig.input.phc_txt_color
            let ret = '';
            if (designType == '' && color) {
                ret = 'border-bottom:1px solid #'+color+';';
            }
            return ret + this.hashTagConfig.text_type.aTagStyleOn
        }
    }
    , methods : {
        publisher () {
            var TagListHeghit = $m('#hashtag_list .text-style ul').height();
			if (TagListHeghit > 66) {
				$m('#hashtag_list .more').addClass('on');
				$m('#hashtag_list .more').click(function() {
					$m(this).parent('.recommend-hashtag').toggleClass('open');
					$m(this).toggleClass('up');
				});
			} else {
				$m('#hashtag_list .more').removeClass('on');
			}
			var hashTagSlide = new Swiper('#hashtag_list .swiper-container',{
				slidesPerView : 10,
				spaceBetween : 20,
			});
        }
        , getTagImg (key) {
            return this.hashTagConfig.img_type.tagImgs[key]
        }
        , changeHashTag (event) {
            if (this.getAdminEditMode()) return false
            let target;
            switch (this.hashTagConfig.input.phc_display_type) {
                case this.displayTypeTextString:
                    target = event.target.parentNode
                    break
                case this.displayTypeImgString:
                    target = event.target.parentNode.parentNode.parentNode
                    break
                default: 
                    return false
            }
            let tag = target.dataset.tag
            let isOn = target.classList.contains('on')
            if (isOn) {
                return false;
            }

            // product list get
            vm.$store.commit('setProductSearchHashTag', {'tag' : tag});

            let lis = target.parentNode.getElementsByTagName('li');
            for (var i=0; i<lis.length; i++) {
                lis[i].classList.remove('on')
            }
            target.classList.add('on')

            let displayType = this.hashTagConfig.input.phc_display_type
            if (displayType != this.displayTypeTextString) {
                return false
            }

            let designType = this.hashTagConfig.input.phc_txt_design_type
            let color = this.hashTagConfig.input.phc_txt_color

            switch (designType) {
                case this.textDesignSquareString :
                    $m('#hashtag_list li').css({ 'background':'none', 'border':'1px solid #'+color });
                    $m('#hashtag_list li a').css({ 'color':'#'+color });
                    $m('#hashtag_list li.on').css({ 'background':'#'+color });
                    $m('#hashtag_list li.on a').css({ 'color':'#fff' });
                    break;
                case this.textDesignCurveString :
                    $m('#hashtag_list li').css({ 'background':'none', 'border':'1px solid #'+color });
                    $m('#hashtag_list li').css({ 'border-radius':'13px' });
                    $m('#hashtag_list li a').css({ 'color':'#'+color });
                    $m('#hashtag_list li.on').css({ 'background':'#'+color });
                    $m('#hashtag_list li.on a').css({ 'color':'#fff' });
                    break;
                default:
                    //$m('#hashtag_list li').css({ 'border' : 'none' });
                    $m('#hashtag_list li a').css({ 'color' : '#' + color, 'font-weight' : 'normal', 'border-bottom' : 'none' });
                    $m('#hashtag_list li.on a').css({ 'font-weight' : 'bold', 'border-bottom' : '1px solid #'+color });
                    break;
            }
        }
    }
    , updated () {
        this.publisher()
    }
})
